
import React, { createContext, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { response } from "../../../../../utils/defaultValues";
import { getFetchCompareSuccess, onSelectReportVersion } from "../projectDescriptionSlice";
import { useProjectDescriptionContext } from "./ProjectDescriptionContext";

const ComparisonModeContext = createContext();

export const useComparisonMode = () => useContext(ComparisonModeContext);

export const ComparisonModeProvider = ({ children }) => {
  const {
    onFetchCompareProperties,
  } = useProjectDescriptionContext();
  const state = useSelector((state) => state.projectDescription);
  const monitoringState = useSelector((state) => state.projectMonitoring);
  const [versionSelected, setVersionSelected] = useState(null);
  const [compareDescriptionText, setCompareDescriptionText] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      monitoringState.isCompareMode &&
      state.versions?.length > 0
      && !!state.currentVersion.ident
      && !state.selectedComparingVersion
      
    ) {
      let temp =  state.versions
        .filter((f) => f.ident !== state.currentVersion.ident)
        .sort((a, b) => a.reportOrder - b.reportOrder);
      dispatch(onSelectReportVersion(temp[0]));
      setLoading(true);
    }
  }, [
    monitoringState.isCompareMode,
    state.currentVersion,
    dispatch,
    state.selectedComparingVersion,
    state.versions
  ]);

  useEffect(() => {
    if (!!state.selectedComparingVersion && !!state.selectedComparingVersion.ident) {
      setVersionSelected(state.selectedComparingVersion);
      onFetchCompareProperties(state.selectedComparingVersion.ident);
    }
  }, [onFetchCompareProperties, state.selectedComparingVersion]);

  useEffect(() => {
    if (
      state.fetchCompare.type === "FETCHED"
    ) {
      setCompareDescriptionText(state.fetchCompare.data);
      dispatch(getFetchCompareSuccess({ ...response, guruDto: [] }));
      setLoading(false);
    }
  }, [dispatch, state.fetchCompare.data, state.fetchCompare.type]);


  return (
    <ComparisonModeContext.Provider
      value={{
        versionSelected,
        loading,
        compareDescriptionText,
        setCompareDescriptionText,
      }}
    >
      {children}
    </ComparisonModeContext.Provider>
  );
};
